module.exports = __webpack_public_path__ + "static/turtle-creek-house45-ba4a66d488e5a52071c4ec084da0be47.jpg";